import { useState, useEffect } from "react";
import axios from 'axios';
import config from "../../Common/Configurations/APIConfig";
import { Link } from "react-router-dom";
import { handleSuccess } from "../../Common/Layout/CustomAlerts";

 export default function ClientProfile({ refreshKey }) {
    const [client, setClient] = useState({});
    const [editedClient, setEditedClient] = useState({});
    const [loading, setLoading] = useState(false);
    const [editMode, setEditMode] = useState(false);

    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken"),
            "Content-Type": "application/json"
        }
    };

    const GetData = () => {
        axios
            .get(config.APIACTIVATEURL + config.GETUSER + "?Id=" + localStorage.getItem("userId"), headerconfig)
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setClient(response.data.data);
                }
            });
    };

    useEffect(() => {
        if (localStorage.getItem('userId')) {
            GetData();
        }
    }, [refreshKey]); 
    
    const startEdit = () => {
        setEditedClient({ ...client });
        setEditMode(true);
    };

    const cancelEdit = () => {
        setEditMode(false);
        setEditedClient({});
    };

    const handleUpdate = () => {
        setLoading(true);
        const payload = {
            id: localStorage.getItem("userId"),
            phoneNumber: editedClient.phoneNumber,
            name: editedClient.name,
            clientName: editedClient.clientName,
            clientId:localStorage.getItem("clientId"),
            isActive: true,
            userType:"CLIENT"
        };

        axios.post(config.APIACTIVATEURL + config.UPDATEPROFILE, payload, headerconfig)
            .then((response) => {
                if (response.data.statusCode === 200) {
                    handleSuccess("Profile updated successfully");
                    setEditMode(false);
                    setEditedClient({});
                    GetData();
                }
                setLoading(false);
            }).catch(() => setLoading(false));
    };

    return (
        <div className="card">
            <div className="card-header bg-soft-danger">
                <h5 className="text-black mb-0">Profile</h5>
            </div>
            <div className="card-body">
                <ul className="list-group">
                    <li className="list-group-item">
                        Company Name : 
                        {editMode ? (
                            <input
                                type="text"
                                className="form-control"
                                value={editedClient.clientName}
                                maxLength={40}
                                onChange={(e) => setEditedClient({ ...editedClient, clientName: e.target.value })}
                            />
                        ) : (
                            <label className="form-label">{client.clientName}</label>
                        )}
                    </li>
                    <li className="list-group-item">
                        Name:
                        {editMode ? (
                            <input
                                type="text"
                                className="form-control"
                                value={editedClient.name}
                                maxLength={40}
                                onChange={(e) => setEditedClient({ ...editedClient, name: e.target.value })}
                            />
                        ) : (
                            <label className="form-label">{client.name}</label>
                        )}
                    </li>
                    <li className="list-group-item">
                        Phone Number:
                        {editMode ? (
                            <input
                                type="text"
                                className="form-control"
                                value={editedClient.phoneNumber}
                                maxLength={14}
                                placeholder="Phone Number with Country Code"
                                onChange={(e) => setEditedClient({ ...editedClient, phoneNumber: e.target.value })}
                            />
                        ) : (
                            <label className="form-label">{client.phoneNumber}</label>
                        )}
                    </li>
                    <li className="list-group-item">
                        Email:<label className="form-label"> {client.email}</label>
                    </li>
                    <li className="list-group-item">
                        Available Credits: <label className="form-label">{client.availableCredits}</label>
                    </li>
                    <li className="list-group-item">
                        SMS Quota: <label className="form-label">{client.smsAvailable}</label>
                    </li>
                    <li className="list-group-item">
                        Email Quota: <label className="form-label">{client.emailAvailable}</label>
                    </li>
                    <li className="list-group-item">
                        Call Quota: <label className="form-label">{client.callAvailable} Mins</label>
                    </li>
                    <li className="list-group-item">
                        Marketing Phone Number: {client.plivoPhoneNumber === null ? (
                            <Link to={"/userdashboard/phonenumbers"} className="btn btn-sm btn-primary">Select Number</Link>
                        ) : (
                            <label className="form-label">{client.plivoPhoneNumber}</label>
                        )}
                    </li>                    
                </ul>
                <div className="mt-3 d-flex justify-content-end">
                    {!editMode ? (
                        <button className="btn btn-warning" onClick={startEdit}>
                            Edit Profile
                        </button>
                    ) : (
                        <>
                            <button className="btn btn-success me-2" onClick={handleUpdate} disabled={loading}>
                                {loading ? "Saving..." : "Save Changes"}
                            </button>
                            <button className="btn btn-secondary" onClick={cancelEdit}>
                                Cancel
                            </button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

